/** Message type byte: first byte of every binary frame. */
export const MessageType = {
  Input: 1,
  Snapshot: 2,
} as const;
export type MessageTypeValue = (typeof MessageType)[keyof typeof MessageType];

export function messageTypeOf(bytes: Uint8Array): MessageTypeValue | undefined {
  const t = bytes[0];
  return t === 1 || t === 2 ? t : undefined;
}
